<template>
  <div class="l-container AggregatesPaymentdetails">
    <h1 class="m-label btn">集計</h1>
    <div class="wrapper">

      <div class="list-box">
        <table-c>
          <tr-c slot="tr-th">
            <th-c style="background: #f6fdff">支払期間</th-c>
            <td-c><input v-model="search.payments_month" type="text" @keyup="searchTable()" placeholder="例) 2018"></td-c>
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watch.company_id" :options="orderedCompanies" label="name" placeholder="会社" :show-labels="false"></multiselect>
            </td-c>
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="orderedOffices" label="name" placeholder="営業所" :show-labels="false"></multiselect>
            </td-c>
          </tr-c>

          <tr-c slot="tr-th">
            <th-c style="background: #f6fdff">除外</th-c>
            <td-c><input v-model="search.not_payments_month" type="text" @keyup="searchTable()" placeholder="例) 2018"></td-c>
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watch.not_company_id" :options="orderedCompanies" label="name" placeholder="会社" :show-labels="false"></multiselect>
            </td-c>
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="orderedOffices" label="name" placeholder="営業所" :show-labels="false"></multiselect>
            </td-c>
          </tr-c>
        </table-c>
      </div>

      <div class="list-box" v-if="aggregate_paymentdetail['1']">
        <table-c>
          <tr-c slot="tr-th">
            <td-c>項目</td-c>
            <th-c>回収予定金額</th-c>
            <th-c>中途解約金額</th-c>
            <th-c>回収見込金額</th-c>
            <th-c>不良債権金額</th-c>
            <th-c>回収金額</th-c>
            <th-c>未回収金額</th-c>
            <th-c>回収率</th-c>
            <th-c>回収率(稼働中)</th-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>1月</th-c>
            <td-c>{{aggregate_paymentdetail['1'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['1'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>2月</th-c>
            <td-c>{{aggregate_paymentdetail['2'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['2'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>3月</th-c>
            <td-c>{{aggregate_paymentdetail['3'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['3'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>4月</th-c>
            <td-c>{{aggregate_paymentdetail['4'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['4'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>5月</th-c>
            <td-c>{{aggregate_paymentdetail['5'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['5'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>6月</th-c>
            <td-c>{{aggregate_paymentdetail['6'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['6'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>7月</th-c>
            <td-c>{{aggregate_paymentdetail['7'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['7'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>8月</th-c>
            <td-c>{{aggregate_paymentdetail['8'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['8'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>9月</th-c>
            <td-c>{{aggregate_paymentdetail['9'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['9'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>10月</th-c>
            <td-c>{{aggregate_paymentdetail['10'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['10'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>11月</th-c>
            <td-c>{{aggregate_paymentdetail['11'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['11'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>12月</th-c>
            <td-c>{{aggregate_paymentdetail['12'].plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail['12'].recover_rate_operation}}</td-c>
          </tr-c>
          <tr-c slot="tr-th">
            <th-c>合計</th-c>
            <td-c>{{aggregate_paymentdetail.sum.plan_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.mid_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.collection_prospects.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.forced_cancellations.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.real_collections.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.unpaid_amounts.toLocaleString()}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.recover_rate}}</td-c>
            <td-c>{{aggregate_paymentdetail.sum.recover_rate_operation}}</td-c>
          </tr-c>
        </table-c>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
// import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/aggregate_paymentdetails'
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'aggregate_paymentdetail',
  pageNames: 'aggregate_paymentdetails'
}

let _ = window._
export default {
  computed: {
    aggregate_paymentdetail () {
      return this.$store.getters.aggregate_paymentdetail
    },

    companies () {
      return this.$store.getters.companies
    },

    orderedCompanies () {
      return _.orderBy(this.companies).reverse()
    },

    offices () {
      return this.$store.getters.offices
    },

    orderedOffices () {
      return _.orderBy(this.offices).reverse()
    }
  },

  data () {
    return {
      search: {
        payments_month: '',
        company_id: '',
        office_id: '',

        not_payments_month: '',
        not_company_id: '',
        not_office_id: ''
      },

      watch: {
        company_id: '',
        office_id: '',

        not_company_id: '',
        not_office_id: ''
      }
    }
  },

  watch: {
    'watch.company_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.company_id = now.id
      } else {
        this.search.company_id = ''
      }
    },

    'watch.not_company_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_company_id = now.id
      } else {
        this.search.not_company_id = ''
      }
    },

    'watch.office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAggregatePaymentdetail()
      vm.getCompanies()
      vm.getOffices()
    })
  },

  methods: {
    searchTable (e) {
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // paymentdetail
        var paramsList = [
          'payments_month',
          'company_id',
          'office_id',

          'not_payments_month',
          'not_company_id',
          'not_office_id'
        ]
        paramsList.forEach((e) => {
          if (search[e]) {
            if (e === 'payments_month') {
              params[e] = [search[e]]
            } else {
              params[e] = search[e]
            }
          }
        })
        console.log(url)
        console.log(params)
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
        // success callback
          console.log(response)
          store.state.item.aggregate_paymentdetail = response.data
        }, (response) => {
        // error callback
        })
      }

      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    getAggregatePaymentdetail () {
      this.$store.dispatch('getAggregatePaymentdetail')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .list-box {
    margin-bottom: 15px;
  }
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  /* padding: 0 !important; */
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
</style>
<style lang="scss">
.AggregatesPaymentdetails {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}



// WEBPACK FOOTER //
// AggregatesPaymentdetails.vue?57faa81c